export const SET_HMO_SUCCESS = "SET_HMO_SUCCESS";
export const ADD_HMO_SUCCESS = "ADD_HMO_SUCCESS";
export const EDIT_HMO_SUCCESS = "EDIT_HMO_SUCCESS";
export const DELETE_HMO_SUCCESS = "DELETE_HMO_SUCCESS";
